import styled from "styled-components";

export const ChatbotGuidanceCase = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .chatbot-container {
    flex: 1;
  }
  .chatbot-footer {
    padding: 20px;
  }
  .chatbot-selectors {
    height: ${({ selectedPatient }) => (selectedPatient ? "68px" : "88px")};
    .process-selects {
      height: ${({ selectedProcess, selectedPartition }) =>
        selectedProcess && selectedPartition
          ? "0px"
          : !selectedProcess && !selectedPartition
            ? "132px"
            : "66px"};
      background-color: #fff;
      position: absolute;
      width: 100%;
      margin-top: ${({ selectedPatient }) =>
        selectedPatient ? "68px" : "88px"};
      /* margin-top: 118px; */
    }
  }

  .button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  .selector {
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 20px 20px 0 20px;
  }
  .selector-label {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
    &__img {
      margin-bottom: 20px;
    }
    &__title {
      font-size: 17px;
      color: #707582;
      text-align: center;
    }
  }
  .options {
    margin: 20px;
    width: 100%;
  }
  .guide-selector-pop-up {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 100;
  }

  .patient-selected-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin-top: 20px;
    .patient-selected {
      width: 100%;
      background-color: #f0f0ff;
      display: flex;
      height: auto;
      border-radius: 14px;
      padding: 10px;
      box-sizing: border-box;
      align-items: center;
      text-align: center;
      justify-content: center;
      cursor: pointer;
      margin-right: 10px;
      height: 40px;
      &__box-image {
        display: flex;
        margin-right: 10px;
        overflow: hidden;
        img {
          width: 17px;
          border-radius: 50%;
          height: 17px;
        }
      }
      &__name {
        color: #16158a;
        text-align: center;
        font-family: "Nunito Sans Bold";
        font-size: 14px;
      }
      &__icon-close {
        font-size: 10px;
        color: #16158a;
        margin-left: 13px;
      }
      &__icon-update {
        font-size: 17px;
        color: #16158a;
        margin-left: 5px;
      }
    }
    .patiet-selected__update-guide {
      display: flex;
      padding: 10px;
      justify-content: center;
      align-items: center;
      font-family: "Nunito Sans";
      font-size: 14px;
      background: rgba(109, 109, 185, 0.12);
      cursor: pointer;
      background-color: #f0f0ff;
      border-radius: 14px;
      color: #16158a;
      white-space: nowrap;
      height: 40px;
      box-sizing: border-box;
    }
  }

  .chatbot-guide-selected {
    background-color: #efeff9;
    padding: 0px 20px 10px 20px;
    /* border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px; */
    .box-guide {
      background-color: #fafafc;
      padding: 10px;
      border-radius: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      color: #707582;
      width: 488;
      &__button {
        padding: 10px;
        border: 2px solid #ffffff;
        border-radius: 14px;
        background-color: #f2f2f8;
        color: #3e3e5b;
        white-space: nowrap;
        margin-left: 10px;
      }
    }
  }
`;

export const Option = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ disabled }) => (disabled ? "#CFD3DD" : "#F0F0FF")};
  margin-bottom: 10px;
  padding: 16px;
  border-radius: 14px;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  &:last-child {
    margin-bottom: 0px;
  }
  .left {
    display: flex;
    align-items: center;
  }
  .number {
    padding: 2px 5px;
    background-color: #ffffff;
    border-radius: 34px;
    font-size: 14px;
    color: ${({ disabled }) => (disabled ? "#CFD3DD" : "#707582")};
    margin-right: 15px;
  }
  .right {
    display: flex;
    align-items: center;
  }
  .title {
    font-size: 20px;
    color: ${({ disabled }) => (disabled ? "#1F1F52" : "#16158a")};
  }
  .right-icon {
    color: ${({ disabled }) => (disabled ? "#1F1F52" : "#6C6BF5")};
    font-size: 13px;
  }
`;
